import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categoria-producto',
  templateUrl: './categoria-productos.component.html',
  styleUrls: ['./categoria-productos.component.css']
})
export class CategoriaProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
